import { Avatar } from "@twilio-paste/core/avatar";
import { Box } from "@twilio-paste/core/box";
import {
  MediaObject,
  MediaFigure,
  MediaBody,
} from "@twilio-paste/core/media-object";
import { Text } from "@twilio-paste/core/text";
import { styled } from "@twilio-paste/core/styling-library";
import { ArtificialIntelligenceIcon } from "@twilio-paste/icons/esm/ArtificialIntelligenceIcon";

import {
  ASSISTANT_NAME_LABEL,
  AUTHOR_NAME_LABEL,
  dataTestIds,
  MessageBlockRole,
} from "@twiliointernal/e2-commons-shared-definitions";
import { AvatarWrapperProps } from "./definitions";

const AvatarWrapperContainer = styled(Box)`
  > [data-paste-element="MEDIA_OBJECT"] {
    flex-direction: column;
    gap: 0.75rem;
  }
  * [data-paste-element="MEDIA_BODY"] {
    width: 100%;
  }
`;

const AvatarContainer = styled(Box)`
  align-items: center;
  display: flex;
  gap: 0.5rem;
  padding-top: 0.75rem;
  padding-left: 0.125rem;
`;

const AvatarWrapper = ({
  children,
  element,
  author,
  role,
  // BoxProps from Paste
  ...rest
}: AvatarWrapperProps) => {
  const isAssistant = role === MessageBlockRole.Assistant;
  const labelText = isAssistant ? ASSISTANT_NAME_LABEL : AUTHOR_NAME_LABEL;

  const dataTestId = isAssistant
    ? dataTestIds.wiseOwlChat.helpAssistantMediaObject
    : dataTestIds.wiseOwlChat.userMediaObject;

  return (
    <AvatarWrapperContainer element={element} {...rest}>
      <MediaObject verticalAlign="top" data-testid={dataTestId}>
        <MediaFigure spacing="space50">
          <AvatarContainer>
            <Avatar
              size="sizeIcon50"
              color={isAssistant ? "decorative20" : "decorative30"}
              {...(role === MessageBlockRole.Assistant
                ? {
                    name: ASSISTANT_NAME_LABEL,
                    icon: ArtificialIntelligenceIcon,
                  }
                : { name: author })}
            />

            <Text as="p" fontSize="fontSize30" fontWeight="fontWeightBold">
              {labelText}
            </Text>
          </AvatarContainer>
        </MediaFigure>

        <MediaBody>{children}</MediaBody>
      </MediaObject>
    </AvatarWrapperContainer>
  );
};

export default AvatarWrapper;
